import ClaimReview from 'components/ViewClaimReview/ClaimReview.component';
import {
	getClaimDetails,
	resetClaim,
	resetClaimAttachments,
} from 'feature/claims/claimSlice';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AppDispatch } from 'store/store';

const ViewClaimReview = () => {
	const param = useParams<{ uuid: string }>();
	const dispatch = useDispatch<AppDispatch>();

	useEffect(() => {
		dispatch(resetClaim());
		dispatch(getClaimDetails(param.uuid as string))
			// the attachments are to be updated again so we reset them
			.then(() => {
				dispatch(resetClaimAttachments());
			});
	}, [dispatch, param.uuid]);

	return <ClaimReview />;
};

export default ViewClaimReview;
